import React, { useState } from 'react';

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
  className?: string;
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({ items, className = '' }) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const toggleItem = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className={`space-y-0 ${className}`}>
      {items.map((item, index) => {
        const isExpanded = expandedId === item.id;
        const isLast = index === items.length - 1;

        return (
          <div
            key={item.id}
            className={`${!isLast ? 'border-b border-gray-200' : ''}`}
          >
            <button
              onClick={() => toggleItem(item.id)}
              aria-expanded={isExpanded}
              aria-controls={`faq-answer-${item.id}`}
              className="w-full text-left py-6 px-4 flex justify-between items-center hover:bg-gray-50 transition-colors duration-200 group"
            >
              <span className="text-lg font-semibold text-gray-900 pr-8 group-hover:text-primary transition-colors">
                {item.question}
              </span>
              <svg
                className={`w-6 h-6 text-primary flex-shrink-0 transition-transform duration-300 ease-in-out ${
                  isExpanded ? 'transform rotate-180' : ''
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            <div
              id={`faq-answer-${item.id}`}
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="px-4 pb-6 text-gray-600 leading-relaxed">
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
